import IntroComponent from '../components/intro.components';
import PointIcon from '../../../assets/point-icon.svg';
import RankBadge from '../../RankBadge';
import ProgressBar from '../../ProgressBar';
import { useEffect, useState } from 'react';
import { ReceivedPointTableComponent } from '../components/received-point-history-table.component';
import { GivenPointTableComponent } from '../components/given-point-history-table.component';
import { getPointBalance } from '../../../apis/article.api';
import { useQuery } from '@tanstack/react-query';
import { convertDay } from '../../../utils/helper.util';
import { Spinner } from '@chakra-ui/react';

const HISTORY_TAB = [
  {
    name: 'Received Twigs history',
    value: 'received'
  },
  {
    name: 'Given Twigs history',
    value: 'given'
  }
];

const RANKS = {
  NEWCOMER: 'newcomer',
  CONTRIBUTOR: 'contributor',
  RESPECTED: 'respected',
  AUTHORITY: 'authority',
  LUMINARY: 'luminary'
};
const AwardedPointsComponent = () => {
  const [selectedTab, setSelectedTab] = useState('received');
  const [nextRank, setNextRank] = useState('');
  const [maxPoints, setMaxPoints] = useState();

  const { data: pointBalance, isLoading } = useQuery({
    queryKey: ['getPointBalance'],
    queryFn: () => getPointBalance(),
    cacheTime: 0
  });

  const handleSelectedTab = (value) => {
    setSelectedTab(value);
  };

  useEffect(() => {
    if (pointBalance) {
      switch (pointBalance?.rank.toLowerCase()) {
        case RANKS.NEWCOMER:
          setNextRank(RANKS.CONTRIBUTOR);
          setMaxPoints(100);
          break;
        case RANKS.CONTRIBUTOR:
          setNextRank(RANKS.RESPECTED);
          setMaxPoints(500);
          break;
        case RANKS.RESPECTED:
          setNextRank(RANKS.AUTHORITY);
          setMaxPoints(2000);
          break;
        case RANKS.AUTHORITY:
          setNextRank(RANKS.LUMINARY);
          setMaxPoints(5000);
          break;

        default:
          setNextRank('contributor');
          setMaxPoints(500);
      }
    }
  }, [pointBalance]);

  if (isLoading) {
    return (
      <div className="fixed top-[50%] left-[50%]">
        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#4CAF50" size="xl" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <IntroComponent
        title="Twigs and Awards"
        des="Check Twigs you have received and given to the community"
      />

      <div className="px-4 md:px-0 flex items-center gap-5 flex-col md:flex-row">
        <div className="bg-white p-6 rounded-[12px] border border-05-seasalt-white shadow-[0px_4px_4px_0px_#F2F3F780] w-full md:w-fit">
          <div className="flex items-center">
            <img src={PointIcon} className="w-5 h-5" alt="" />
            <p className="font-[800] ml-[5px] text-sm">Twigs balances</p>
          </div>
          <div className="mt-6 flex flex-wrap md:flex-nowrap gap-4">
            <div className="flex flex-col gap-2 w-full md:w-auto pr-12 pb-[12px] border-b md:border-b-0 border-r-0 md:border-r border-[#E6E7EB]">
              <p className="text-05-growth-green-900 font-[800] text-sm">Total Twigs Given</p>
              <p className="text-2xl text-growth-green-900 font-[800]">
                {pointBalance?.totalSentPoint}
              </p>
              <p className="text-growth-green-900 text-sm">
                To {pointBalance?.totalSentUsers}{' '}
                {pointBalance?.totalSentUsers === 1 ? 'Writer' : 'Writers'}
              </p>
            </div>
            <div className="flex flex-col gap-2 w-full md:w-auto pr-4 pb-[12px] border-b md:border-b-0 border-r-0 md:border-r border-[#E6E7EB]">
              <p className="text-05-growth-green-900 font-[800] text-sm">Total Twigs Earned</p>
              <p className="text-2xl text-growth-green-900 font-[800]">
                {pointBalance?.totalReceivedPoint}
              </p>
              <p className="text-growth-green-900 text-sm">
                From {pointBalance?.totalReceivedUsers}{' '}
                {pointBalance?.totalReceivedUsers === 1 ? 'Reader' : 'Readers'}
              </p>
            </div>
            <div className="flex flex-col gap-2 pb-[12px]">
              <p className="text-05-growth-green-900 text-sm font-[800]">Daily Giving Twigs</p>
              <p className="text-2xl text-growth-green-900 font-[800]">
                {pointBalance?.dailyPointRemaining} /{' '}
                <span className="text-xl font-[600] text-jet-black">20</span>
              </p>
              <p className="text-dim-gray text-sm italic">Resets daily at midnight UTC</p>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-[12px] border border-05-seasalt-white shadow-[0px_4px_4px_0px_#F2F3F780] w-full md:w-fit">
          <div>
            <p className="font-[800] text-sm">Ranks & Benefits</p>
            <p className="text-dim-gray text-sm">You can give Twigs, post articles and comments!</p>
          </div>
          <div className="flex gap-8 mt-6">
            <div className="flex flex-col gap-4 items-center">
              <RankBadge
                rank={pointBalance?.rank}
                className="w-fit"
                iconSize={'w-5 h-5'}
                textSize={'text-sm'}
              />
              <p className="text-growth-green-900 text-sm">
                Unlocked on {convertDay(pointBalance?.unlockedAt)}
              </p>
            </div>
            {pointBalance?.rank !== 'Luminary' && (
              <div className="flex flex-col gap-4">
                <RankBadge
                  isBlur
                  rank={nextRank}
                  className="w-fit"
                  iconSize={'w-5 h-5'}
                  textSize={'text-sm'}
                />
                <div className="w-full">
                  <p
                    data-testid="process-twigs-point"
                    className="text-growth-green-900 text-sm mb-2 text-center"
                  >
                    {pointBalance?.totalReceivedPoint}/{maxPoints} Twigs
                  </p>
                  <ProgressBar
                    bgColor={
                      'linear-gradient(90deg, #C8E6C9 1.02%, #4CAF50 55.95%, #204A22 91.59%)'
                    }
                    isCalculateRank
                    value={pointBalance?.totalReceivedPoint}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div>
        <div className="flex mb-4 overflow-x-auto no-scrollbar">
          {HISTORY_TAB.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center gap-2 cursor-pointer"
              onClick={() => handleSelectedTab(item.value)}
            >
              <p
                className={`text-sm whitespace-nowrap ${selectedTab === item.value ? 'text-[#333333] font-[800]' : 'text-[#808080] font-[600]'} px-8`}
              >
                {item.name}
              </p>
              <div
                className={`h-[4px] w-full ${selectedTab === item.value ? 'bg-[#4CAF50]' : 'bg-[#E6E7EB]'} rounded-[10px]`}
              ></div>
            </div>
          ))}
        </div>
        {selectedTab === 'received' && <ReceivedPointTableComponent tab={selectedTab} />}
        {selectedTab === 'given' && <GivenPointTableComponent tab={selectedTab} />}
      </div>
    </div>
  );
};

export default AwardedPointsComponent;
